// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul.basics[data-v-43ceb770]{font-size:.9em;line-height:1.2rem;margin:.5em 0;padding:0}ul.basics li[data-v-43ceb770]{list-style:none;margin:.15em 0;padding:0}ul.basics li .icon[data-v-43ceb770]{margin:0 .25em 0 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
